import BaseModule from '@/store/baseModule';
import registerPayloadTypes from '@/store/modules/logbook/payloadTypes';
import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import BaseModulePlugins from '@/store/baseModule/plugins';
import LogbooksService from '@/services/services/logbooks.service';

export default (store) => {
  store.registerModule(
    'logbook',
    new BaseModule({
      sortChoices: ['entry_datetime'],
      searchAttributesArray: [
        'resume',
        'author_name',
        'date_string',
        'payload',
      ],
      serviceAPI: LogbooksService,
      makeQueryParams: makeListRequest({
        dateField: 'entry_datetime',
      }),
    })
  );

  store.dispatch('logbook/toogleViewTable');

  const basePlugin = new BaseModulePlugins({
    paramId: 'propertyId',
    module: 'logbook',
    store,
  });

  basePlugin.onInit(() => {
    basePlugin.persistVuexMutationsToLocalStorage([
      'SET_ATTRIBUTES_OBJ',
      'SET_ITEMS_SORT_BY',
      'SET_VIEW_TABLE',
      'SET_ORDER_ASC',
    ]);

    store.subscribe((mutation) => {
      if (
        mutation.type === 'properties_360/SET_CURRENT_REQUEST' &&
        mutation.payload
      ) {
        store.dispatch(`logbook/setFilterAttribute`, {
          attribute: 'property_id',
          serverSide: true,
          values: [mutation.payload],
          useDelay: false,
        });
      }
    });

    basePlugin.addItemsToAttributesObjRefWhenTheyAreLoaded({
      serverSide: true,
      attribute: 'payload_type_id',
      filter: 'logbook/payloadTypes',
    });
    basePlugin.addItemsToAttributesObjRefWhenTheyAreLoaded({
      serverSide: true,
      attribute: 'origin_id',
      filter: 'logbook/origins',
    });

    basePlugin.initAttributeFiltersWhenAttributesObjRefIsLoaded({
      loadingAttributes: ['payload_type_id', 'origin_id'],
    });
  });

  registerPayloadTypes(store);
};
